import React, { lazy, memo } from 'react'
import SuspenseWithCatch from '../ui/SuspenseWithCatch'
import SomethingWentWrong from '../ui/SomethingWentWrong'

import Loading from '../ui/Loading'
import { Bundles, loadBundle } from '../../util/moduleLoader'

const AuthPasswordAsync = lazy(() => loadBundle(Bundles.Auth).then((bundle) => ({ default: bundle.AuthPassword })))

const AuthPassword = () => {
  return (
    <SuspenseWithCatch fallback={<SomethingWentWrong />} loading={<Loading />}>
      <AuthPasswordAsync />
    </SuspenseWithCatch>
  )
}

export default memo(AuthPassword)
